import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 flex justify-center items-center flex-col" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "mb-3" }

import { useI18n } from "vue-i18n";
import oculaiLogoSrc from "shared/assets/imgs/logo/logo-multiple-no-padding.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'SessionExpired',
  setup(__props) {

const { t } = useI18n();
const refreshPage = () => {
  window.location.reload();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "mx-auto h-12 w-auto mb-6",
      src: _unref(oculaiLogoSrc),
      alt: "oculai logo"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("authentication.session_expired.message")), 1),
    _createElementVNode("div", {
      onClick: refreshPage,
      class: "cursor-pointer text-blue-700 hover:underline"
    }, _toDisplayString(_unref(t)("authentication.session_expired.refresh_page")), 1)
  ]))
}
}

})